import {
  IconCalendarEvent,
  IconCar,
  IconCircleDot,
  IconCarGarage,
  IconChartLine,
  IconFilePlus,
  IconFiles,
  IconFolder,
  IconMail,
  IconReceipt,
  IconTool,
  IconTruckDelivery,
  IconUsers,
  type Icon,
} from '@tabler/icons-react';
import type { HitroDejanje } from './zacetna';
import { sme, type Podrocje, type Raven } from '../seja/pravice';
import type { Pravice } from '../seja/seja';

/** Hitra dejanja modula Prodaja vozil; brez modula v paketu se ne pokažejo. */
export const DEJANJA_PRODAJE: HitroDejanje[] = ['VOZILA', 'POVPRASEVANJA', 'ANALIZE'];

/** Hitra dejanja modula Delavnica; brez modula v paketu se ne pokažejo, v paketu samo z Delavnico so prva. */
export const DEJANJA_DELAVNICE: HitroDejanje[] = [
  'TERMINI',
  'SPREJEM_VOZILA',
  'DELOVNI_NALOGI',
  'VOZILA_STRANK',
  'HOTEL_GUM',
];

/** Pravica, ki jo dejanje potrebuje (vloga uporabnika); brez nje dejanja ni. */
export const PRAVICE_DEJANJ: Record<HitroDejanje, [Podrocje, Raven]> = {
  NOV_RACUN: ['RACUNI', 'UREJANJE'],
  NOV_PREDRACUN: ['PREDRACUNI', 'UREJANJE'],
  VOZILA: ['VOZILA', 'PREGLED'],
  OSEBE: ['STRANKE', 'PREGLED'],
  RACUNI: ['RACUNI', 'PREGLED'],
  PREDRACUNI: ['PREDRACUNI', 'PREGLED'],
  POVPRASEVANJA: ['PONUDBA', 'PREGLED'],
  ANALIZE: ['ANALIZE', 'PREGLED'],
  TERMINI: ['DELAVNICA', 'PREGLED'],
  SPREJEM_VOZILA: ['DELAVNICA', 'UREJANJE'],
  DELOVNI_NALOGI: ['DELAVNICA', 'PREGLED'],
  VOZILA_STRANK: ['DELAVNICA', 'PREGLED'],
  HOTEL_GUM: ['DELAVNICA', 'PREGLED'],
};

/**
 * Vidna hitra dejanja v vrstnem redu uporabnika: brez skritih, brez dejanj modulov, ki jih paket nima, in brez dejanj,
 * za katera uporabnik nima pravice. Dokler uporabnik vrstnega reda ne spremeni (privzeti red), so v paketu samo z
 * Delavnico njena dejanja na začetku.
 */
export function vidnaDejanja(
  red: HitroDejanje[],
  skrita: HitroDejanje[],
  prodaja: boolean,
  delavnica: boolean,
  privzeto: HitroDejanje[],
  pravice?: Pravice,
): HitroDejanje[] {
  const vPaketu = red.filter(
    (k) => (prodaja || !DEJANJA_PRODAJE.includes(k)) && (delavnica || !DEJANJA_DELAVNICE.includes(k)),
  );
  const urejena =
    delavnica && !prodaja && red.join() === privzeto.join()
      ? [
          ...vPaketu.filter((k) => DEJANJA_DELAVNICE.includes(k)),
          ...vPaketu.filter((k) => !DEJANJA_DELAVNICE.includes(k)),
        ]
      : vPaketu;
  return urejena.filter((k) => !skrita.includes(k) && sme(pravice, ...PRAVICE_DEJANJ[k]));
}

/** Gumbi v vrstici hitrih dejanj začetnega zaslona po id-ju s strežnika (enum HitroDejanje). */
export const HITRA_DEJANJA: Record<HitroDejanje, { naziv: string; Ikona: Icon; na: string }> = {
  NOV_RACUN: { naziv: 'Novi račun', Ikona: IconReceipt, na: '/racuni/nov' },
  NOV_PREDRACUN: { naziv: 'Novi predračun', Ikona: IconFilePlus, na: '/predracuni/nov' },
  VOZILA: { naziv: 'Vozila', Ikona: IconCar, na: '/vozila' },
  OSEBE: { naziv: 'Osebe', Ikona: IconUsers, na: '/osebe' },
  RACUNI: { naziv: 'Računi', Ikona: IconFolder, na: '/racuni' },
  PREDRACUNI: { naziv: 'Predračuni', Ikona: IconFiles, na: '/predracuni' },
  POVPRASEVANJA: { naziv: 'Povpraševanja', Ikona: IconMail, na: '/povprasevanja' },
  ANALIZE: { naziv: 'Analize', Ikona: IconChartLine, na: '/analize' },
  TERMINI: { naziv: 'Termini', Ikona: IconCalendarEvent, na: '/delavnica/termini' },
  SPREJEM_VOZILA: { naziv: 'Sprejem vozila', Ikona: IconTruckDelivery, na: '/delavnica/sprejem' },
  DELOVNI_NALOGI: { naziv: 'Delovni nalogi', Ikona: IconTool, na: '/delavnica/nalogi' },
  VOZILA_STRANK: { naziv: 'Vozila strank', Ikona: IconCarGarage, na: '/delavnica/vozila' },
  HOTEL_GUM: { naziv: 'Hotel za gume', Ikona: IconCircleDot, na: '/delavnica/gume' },
};
